import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ca20610"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "display-4 mt-sm-5 fw-bold pt-5 text-20 text-80" }, " 신청 완료 ", -1))
const _hoisted_2 = { class: "mt-3 lh-sm text-14 text-52" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 원더플 피플로 선정된 분들께는 ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 카카오 알림톡을 보내드려요. ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "user-code-wraper cola-color font-Pretendar text-center d-flex flex-column justify-content-center align-items-center"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "fw-bold text-20" }, " 캠퍼스 챌린지 참여 코드 ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-3 text-14" }, " 안내받은 참여코드 8자리를 입력해주세요 ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mt-1 mt-sm-3 text-11" }, [
  /*#__PURE__*/_createTextVNode(" 캠퍼스 챌린지는 캠퍼스 리더로 선정된 분들만 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 참여 신청 할 수 있습니다. ")
], -1))
const _hoisted_12 = {
  key: 0,
  class: "error-message mt-3 text-danger"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "display-4 mt-2 fw-bold pt-5 text-50 text-20" }, " 신청 완료 ", -1))
const _hoisted_14 = { class: "footer-btn-group" }

import type { Challenge } from './model/challenge';
import { type DeepReadonly, inject, nextTick, reactive, type Ref, ref, watch } from 'vue';
import ParticipantStep1 from '@/templates/campaign-cocacola-season-6/components/participant-step1.vue';
import ParticipateSuccess from '@/templates/campaign-cocacola-season-6/components/participate-success.vue';
import UserCodeInput from '@/templates/campaign-cocacola-season-6/components/user-code-input.vue';
import ColaButton from '@/templates/campaign-cocacola-season-6/components/cola-button.vue';
import { request } from '@/utils';
import _ from 'lodash';
import { IProgram } from '@/types/program';
import PopupError from '@/templates/campaign-cocacola-season-6/components/popups/popup-error.vue';

interface Props {
  challenges: Challenge[];
  type: 'participate' | 'collect';
  challengeType: 'everyone' | 'campus';
}

interface FormValue {
  collection_challenge?: number;
  challenge_id?: number;
  people_collection?: string;
  group_name?: string;
  collecting_people_number?: number;
  programId?: number;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    challenges: null,
    type: null,
    challengeType: null
  },
  setup(__props: any) {

const props = __props as {
  challenges: Challenge[];
  type: 'participate' | 'collect';
  challengeType: 'everyone' | 'campus';
}


const activeStep = ref(1);
const userCode = ref('');
const codeError = ref('');

// List of valid passcodes - you can edit this later
const validPasscodes = [
  'IKsT05ob',
  'uSP9D15T',
  'X1D0FiJW',
  '62MqUUEn',
  'j2mPqqMW',
  'qbNUCxDE',
  'MXYldFbd',
  'WQBlDBmG',
  'tU9E3Qe4',
  'nhqJwewJ',
  'JntyUHxF',
  'e9ivHf2u',
  'r2P8sr8i',
  'hLludOKi',
  'Li1H1OCI',
  'B3453guO',
  'TfBRg8IF',
  'QP8w5BB2',
  'tLpaHOZL',
  '9kI3TfAs',
  'WyQELbwX',
  'Pu37sn9X',
  'DsahjWQV',
  'xIRcFVfM',
  'Eov8W1CN',
  '4qbrvxu3',
  'UNh2gvE1',
  'nBxmCGiR',
  '7dHLonQS',
  'xepH3EDR',
  'K3fkHs1r',
  'iibmWTP8',
  'C9xH7ITd',
  'cb0mDVhg',
  'iBmRiXiP',
];

// Watch for changes in userCode to clear error message
watch(userCode, () => {
  if (codeError.value) {
    codeError.value = '';
  }
});


const isActive = (challenge: Challenge): boolean => {
  const now = new Date();
  if (props.type === 'participate') {
    return now >= challenge.recruitmentFrom && now <= challenge.recruitmentTo;
  } else {
    return now >= challenge.collectionFrom && now <= challenge.collectionTo;
  }
};
props.challenges.find(
    (c) => isActive(c));

async function callParticipate(formValue: FormValue, callback: () => void) {
  try {
    let programId = formValue.programId;
    await request.post(`programs/${programId}/participate`, formValue, { loading: { silent: true } });
    callback();
  } catch (e) {
    const status = _.get(e, 'status');
    const errorMsg = _.get(e, 'message');
    const code = _.get(e, 'code');
    // request.ts已经处理过这个code了
    if (status !== 401 && String(code) !== '40305') {
      errMsg.value = errorMsg;
      showPopup('error');
    }
    throw e;
  }
}
const errMsg = ref('');
async function showPopup(key: keyof typeof popupVisible) {
  await nextTick();
  popupVisible[key] = true;
}

const popupVisible = reactive({
  success: false,
  error: false,
});
function hidePopup(key?: keyof typeof popupVisible) {
  if (key) {
    popupVisible[key] = false;
  } else {
    Object.keys(popupVisible).forEach((k) => {
      const popupKey = k as keyof typeof popupVisible;
      if (popupVisible[popupKey]) {
        popupVisible[popupKey] = false;
      }
    });
  }
}
const dateComplete = ref(`${'7'}월 ${'15'}일`);
const nextStep1 = (value: FormValue) => {
  // append data Call API
  // activeStep.value = activeStep.value + 1;
  if (props.challenges.findIndex(item => item.id === value?.challenge_id) == 1) {
    dateComplete.value = `${'8'}월 ${'15'}일`;
  }
  if (props.challengeType === 'everyone') {
    callParticipate({
      collection_challenge: 2,
      people_collection: 'group_type',
      group_name: value.group_name,
      collecting_people_number: value.collecting_people_number,
      programId: value.programId
      // organization_type: 'org_type'
    }, () => {
      activeStep.value = activeStep.value + 1;
    });
  } else {
    // For campus challenge, check user code first
    if (userCode.value) {
      activeStep.value = 2;
    }
  }
};

const nextStep1Campus = (value: FormValue) => {
  callParticipate({
    collection_challenge: 1,
    people_collection: 'group_type',
    group_name: value.group_name,
    collecting_people_number: value.collecting_people_number,
    programId: value.programId
    // organization_type: 'org_type'
  }, () => {
    activeStep.value = activeStep.value + 1;
  });
};

const checkCode = () => {
  // Clear previous error
  codeError.value = '';

  // Check if user code is in the list of valid passcodes
  if (validPasscodes.includes(userCode.value.trim())) {
    // Code is valid, proceed to next step
    activeStep.value = 2;
  } else {
    // Code is invalid, show error message
    codeError.value = '올바른 참여코드를 입력해주세요.';
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.challengeType == 'everyone')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (activeStep.value == 1)
            ? (_openBlock(), _createBlock(ParticipantStep1, {
                key: 0,
                challenges: __props.challenges,
                type: __props.type,
                "challenge-type": 'everyone',
                onNext: nextStep1
              }, null, 8, ["challenges", "type"]))
            : _createCommentVNode("", true),
          (activeStep.value == 2)
            ? (_openBlock(), _createBlock(ParticipateSuccess, { key: 1 }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _createElementVNode("h2", _hoisted_2, [
                    _hoisted_3,
                    _hoisted_4,
                    _createTextVNode(" " + _toDisplayString(dateComplete.value) + " 금요일에 ", 1),
                    _hoisted_5,
                    _hoisted_6,
                    _hoisted_7
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (activeStep.value == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _hoisted_11,
                _createVNode(UserCodeInput, {
                  modelValue: userCode.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userCode).value = $event)),
                  onSubmit: checkCode
                }, null, 8, ["modelValue"]),
                (codeError.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(codeError.value), 1))
                  : _createCommentVNode("", true),
                _createVNode(ColaButton, {
                  title: "다음단계로",
                  class: "mt-5",
                  disabled: !userCode.value,
                  type: "button",
                  border: true,
                  responsive: "",
                  onClick: checkCode
                }, null, 8, ["disabled"])
              ]))
            : _createCommentVNode("", true),
          (activeStep.value == 2)
            ? (_openBlock(), _createBlock(ParticipantStep1, {
                key: 1,
                challenges: __props.challenges,
                type: __props.type,
                "challenge-type": 'campus',
                onNext: nextStep1Campus
              }, null, 8, ["challenges", "type"]))
            : _createCommentVNode("", true),
          (activeStep.value == 3)
            ? (_openBlock(), _createBlock(ParticipateSuccess, { key: 2 }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 64)),
    _createVNode(PopupError, {
      modelValue: _unref(popupVisible).error,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(popupVisible).error) = $event)),
      title: errMsg.value
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            class: "footer-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (hidePopup()))
          }, " 확인했어요 ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})